import React from 'react';

import { Typography } from '@mui/material';

import RelatedTile from '../RelatedTile';

import type { AccountRelatedContact } from './types';

interface Props {
  relatedContact: AccountRelatedContact;
}

export default function AccountRelatedContactTile({ relatedContact }: Props) {
  const fields = [
    { label: 'Account Name', value: relatedContact.accountName },
    { label: 'Title', value: relatedContact.title },
    { label: 'Mobile', value: relatedContact.mobilePhone },
  ];

  return (
    <RelatedTile
      fields={fields}
      heading={
        <Typography variant="subtitle1" component="h3">
          {relatedContact.name}
        </Typography>
      }
    />
  );
}
